import React from "react";

import "./NewCustomerSuccessScreen.css";

import { NewCustomerSuccessIcon } from "./../Common/Svg";
import {
  Heading,
  Text,
  Subtitle,
  HorizontalLine,
} from "./../../StyledComponents";
import PackageTab from "./../Common/PackageTab/PackageTab";

import WhatHappensNext from "./Components/WhatHappensNext";
import OrderDetails from "./Components/OrderDetails";

import { SalesContext } from "./../../Context/SalesContext";
import {
  addBeforeloadEvent,
  filterNumbers,
  getDrivePackageImageURL,
  isMobileView,
  removeBeforeloadEvent
} from "./../../Utility/utility";
import {
  tagOnSuccessPageLoad
} from "../../Tagging/NewCustomerTagging";
import FibrePackageDetails from "../Common/FibrePackageDetails/FibrePackageDetails";
import IncludedServiceComponent from "../../Components/Common/IncludedServiceComponent/IncludedServiceComponent";
import DiscountIcon from "../Common/Svg/DiscountIcon";
import PurplePromotionIcon from '../Common/Svg/PurplePromotionIcon';

const NewCustomerSuccessScreen = (_props) => {
  const context = React.useContext(SalesContext);

  const discountMonthValue = context.selectedContractTerm?.discountTerm?.split(" ");

  const selectedPackageSpeed =
    filterNumbers(context.selectedPackage.download) +
    "/" +
    context.selectedPackage.upload;

  const selectedPackageData = {
    imageUrl: getDrivePackageImageURL(context.selectedPackage.provider),
    type: `Fibre ${context.selectedPackage.dataCap.toLowerCase()}`,
    speed: selectedPackageSpeed,
    price: `R${context.selectedPackage.productPrice.value} PM`,
    contractTerm: context.selectedContractTerm
  };

  const selectedAdditionalServiceKeys = Object.keys(
    context.selectedAdditionalServices
  ).filter((e) => context.selectedAdditionalServices[e] === true);

  let selectedAdditionalServices = [];
  let additionalServicesVAS = [];

  if (context.additionalServices && context.additionalServices.serviceCategories) {
    context.additionalServices.serviceCategories.map((service) => {
      if (!service.offerId)
        additionalServicesVAS.push(service);
    })
  }

  if (additionalServicesVAS) {
    selectedAdditionalServices = additionalServicesVAS.filter((e) =>
      selectedAdditionalServiceKeys.find((key) => key === e.vasCategory)
    );
  }

  let deliveryAddress = "",
    contactPerson = "";

  try {
    if (context.deliveryAddressType?.toUpperCase() === 'To another address'.toUpperCase()) {
      deliveryAddress = `${context.deliveryAddress.unitNumber ? context.deliveryAddress.unitNumber + "," : ""} ${context.deliveryAddress.buildingName ? context.deliveryAddress.buildingName + "," : ""} ${context.deliveryAddress.streetAddress}, ${context.deliveryAddress.suburb}, ${context.deliveryAddress.city}, ${context.deliveryAddress.province}, ${context.deliveryAddress.postalCode}`;
    } else {
      deliveryAddress = `${context.installationAddress.unitNumber ? context.installationAddress.unitNumber + "," : ""} ${context.installationAddress.buildingName ? context.installationAddress.buildingName + "," : ""} ${context.installationAddress.streetNumber} ${context.installationAddress.streetName}, ${context.installationAddress.suburb}, ${context.installationAddress.city}, ${context.installationAddress.province}, ${context.installationAddress.postalCode}`;
    }
    contactPerson = `${context.userDetails?.firstName} ${context.userDetails?.lastName} (${context.userDetails?.contactNumber})`;
  } catch (error) {
    console.log(error);
  }

  React.useEffect(() => {

    tagOnSuccessPageLoad(
      context.userDetails.referenceNo || context.userDetails.quoteNumber,
      'NC Order success',
      context.userDetails.contactNumber
    );

    window.onpopstate = (e) => {
      e.preventDefault();
      window.location.href = "/vodacom/fibre/sales/leads";
    }

    removeBeforeloadEvent();
  }, [])

  React.useEffect(() => {
    addBeforeloadEvent();
    return () => {
      removeBeforeloadEvent();
    };
  }, []);

  const getContractTerm = () => {
    switch (context.selectedContractTerm.duration) {
      case "12 Months": 
        return ("x 12")
      case "24 Months": 
        return ("x 24")
      default:
        return ("")
    }
  }

  return (
    <div
      className="success-screen__container"
      automationid="SalesLeads_Div_Success_1"
    >
      <div
        className="success-screen__logo"
        automationid="SalesLeads_Div_Success_2"
      >
        <NewCustomerSuccessIcon />
      </div>
      <div
        className="success-screen__data"
        automationid="SalesLeads_Div_Success_3"
      >
        <Heading
          size="3rem"
          automationid="SalesLeads_H1_Success_1"
          className="success-screen__heading"
        >
          Thank you, {context.userDetails.firstName}!
        </Heading>

        <Text
          className="success-screen__subtitle"
          automationid="SalesLeads_H4_Success-g_1"
          aligntext="text"
        >
          Your order was successful and we can start preparing your order.
        </Text>
        <div
          className="success-screen__dash"
          automationid="SalesLeads_Div_Success-g_1"
        ></div>
        <Text
          className="success-screen__subtitle"
          automationid="SalesLeads_H4_Success-g_3"
          aligntext="center"
        >
          We’ve sent an email to{" "}
          <span
            automationid="SalesLeads_Span_Success-g_3"
            style={{ fontWeight: "bold" }}
          >
            {` ${context.userDetails.email} `}
          </span>{" "}
          to confirm your order and delivery details.
          <br />
          Once your order is ready for delivery, our courier partner will
          contact you to confirm delivery.
        </Text>

        <br />

        <OrderDetails
          referenceNumber={
            context.userDetails.referenceNo || context.userDetails.quoteNumber
          }
          deliveryAddress={deliveryAddress}
          contactPerson={contactPerson}
        />

        <Subtitle automationid="SalesLeads_H4_Success-g_5">Your order</Subtitle>
        <HorizontalLine automationid="SalesLeads_Hr_Success-g_6" />
        <PackageTab data={selectedPackageData} />
        <FibrePackageDetails speed={selectedPackageData.speed} type={selectedPackageData.type}></FibrePackageDetails>
        {
          (context.selectedPackageType == "Vodacom One Deals" || context.selectedPackageType == "Premium Fibre Deals") && context.selectedContractTerm?.inclusions?.length > 0 ?
            <IncludedServiceComponent
              inclusionsList={context.selectedContractTerm?.inclusions}
              bgcolor="#FFFFF"
              isDevice={false}
            />
            :
            null
        }
        {isMobileView() &&
          <div className="mobile-price">
            {context.selectedContractTerm.discountTerm &&

              <p className='generic-discount-container review-order-discount' automationid={`SalesLeads_p_packageDiscount${context.selectedContractTerm.discountAmount}_1`} >
                <PurplePromotionIcon />
                <Text
                  lineheight="0"
                  fontWeight="700"
                  fontSize="14px"
                  color="#9C2AA0"
                  automationid={`SalesLeads_p_packageDiscount${context.selectedContractTerm.discountAmount}_2`}
                >
                  {`  `} R{context.selectedContractTerm.discountAmount} off for {discountMonthValue[0] === "1" ? "1 month" : `${discountMonthValue[0]} months`}
                </Text>
              </p>
            }
            <Text
              style={context.selectedContractTerm.discountTerm ? { textAlign: "right"} : {textAlign: "right", width: "100%"}}
              automationid="SalesLeads_P_ReviewOrder_41"
              fontSize="16px"
            >
              <span
                automationid="SalesLeads_Span_ReviewOrder_2"
                style={{ fontWeight: "bold" }}
              >
                R{context.selectedPackage.productPrice.value} {getContractTerm()}
              </span>
            </Text>
          </div>}

        {
          context.additionalVas ?
            context.additionalVas.map((item) => {
              if (item.category == "superWifi")
                return (
                  <div>
                    <HorizontalLine automationid="SalesLeads_Hr_Success-g_7" />
                    <div className="additional-vas">
                      <div className="image-wrapper-success">
                        <img src={item.imgUrl} />
                      </div>
                      <div className="additional-vas-details">
                        <div className="tbyb-promotion-success">Try before you buy</div>
                        <div className="additional-vas-details-wrapper-success">
                          <div className="details-lte">
                            <p automationid="" className="lte-text">{item?.displayName}</p>
                          </div>
                          <p automationid="" className="quantity-additional-vas">Qty: 1</p>
                          <div className="wrapperAdditional">
                            <p
                              automationid=""
                              className="price-additional"
                            >
                              {item?.price} {parseInt(item?.contractTerm) ? "PM" : ""}
                            </p>
                          </div>
                        </div>
                        <div className="new-customer-promotion-text-success">FREE 14-day trial</div>
                        <div className="new-customer-discount-text-wrapper">
                          <DiscountIcon></DiscountIcon>
                          <div className="new-customer-discount-text">{item.discount}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                )
              else
                return (
                  <div>
                    <HorizontalLine automationid="SalesLeads_Hr_Success-g_7" />
                    <div className="additional-vas">
                      <div className="image-wrapper-success" style={ item.category == "contractCover" ? {marginRight: '3em'} : ''}>
                        <img src={item.imgUrl} style={ item.category == "contractCover" ? {width: '100%'} : ''} />
                      </div>
                      <div className="additional-vas-details">
                        <div className="additional-vas-details-wrapper-success">
                          <div className="details-lte">
                            <p automationid="" className="lte-text">{item?.displayName}</p>
                          </div>
                          <div className="wrapperAdditional">
                            <p
                              automationid=""
                              className="price-additional"
                            >
                              {item?.price} {parseInt(item?.contractTerm) || item.category == "contractCover" ? "PM" : ""}
                            </p>
                          </div>
                        </div>
                        <div className="new-customer-promotion-text-success">{item.category == "contractCover" ? "Pays for your contract expenses in the event of death" : ""}</div>
                      </div>
                    </div>
                  </div>
                )
            })

            :
            null
        }

        <HorizontalLine automationid="SalesLeads_Hr_Success-g_7" />

        {
          selectedAdditionalServices.length > 0 ?
            <React.Fragment>
              <Subtitle automationid="SalesLeads_H4_Success-g_9">
                Additional services
              </Subtitle>
              <HorizontalLine automationid="SalesLeads_Hr_Success-g_8" />
              <PackageTab
                data={selectedAdditionalServices}
                hideTrash={true}
              />
              <HorizontalLine automationid="SalesLeads_Hr_Success-g_9" />
            </React.Fragment>
            :
            null
        }
      </div>
      <WhatHappensNext additionalServices={selectedAdditionalServices} />
    </div>
  );
};

export default NewCustomerSuccessScreen;
